import { useEntities } from "@/hooks/useCommonQueries";
import { BasicTable } from "@/components/ui/BasicTable";
import PageTemplate from "@/components/page-template/PageTemplate";
import { Link } from "react-router-dom";
import { useAuth } from "@/providers/AuthProvider";
import { LoadingScreen } from "@/components/ui/LoadingScreen";
import ErrorScreen from "@/components/ui/ErrorCard";

export default function AllEntitiesPage() {
  const { currentTenant, safeNavigate } = useAuth();
  const { data: entities, isLoading, error } = useEntities();

  if (isLoading) {
    return <LoadingScreen fullPage={false} />;
  }

  if (error) {
    return <ErrorScreen error={error.message} />;
  }

  return (
    <PageTemplate
      title="All Entities"
      description="Manage all entities in the system"
    >
      <BasicTable
        columns={[
          {
            header: "Name",
            accessor: "name",
            cellRenderer: (entity) => (
              <Link
                to={`/org/${currentTenant?.id}/entities/${entity.name}`}
                onClick={(e) => {
                  e.preventDefault();
                  safeNavigate(
                    `/org/${currentTenant?.id}/entities/${entity.name}`,
                  );
                }}
                className="text-blue-600 hover:text-blue-800"
              >
                {entity.name}
              </Link>
            ),
          },
          {
            header: "Created At",
            accessor: "created_at",
            cellRenderer: (entity) =>
              new Date(entity.created_at).toLocaleDateString(),
          },
          {
            header: "Updated At",
            accessor: "updated_at",
            cellRenderer: (entity) =>
              new Date(entity.updated_at).toLocaleDateString(),
          },
        ]}
        data={(entities ?? []).sort((a, b) => a.name.localeCompare(b.name))}
      />
    </PageTemplate>
  );
}
